import { useQuery } from '@tanstack/react-query';
import { startOfDay, endOfDay } from 'date-fns';
import { dashboardApi, dashboardQueryKeys } from '../api/dashboard.api';

/**
 * Team efficiency uses its own date range (the same picker as the KPI page).
 * Each lawyer's KPI + the firm average are computed server-side for [from, to].
 */
export function useMDTeamEfficiency(range: { from?: Date; to?: Date }) {
  const from = range.from ? startOfDay(range.from).toISOString() : undefined;
  const to = range.to ? endOfDay(range.to).toISOString() : undefined;

  return useQuery({
    queryKey: dashboardQueryKeys.mdTeamEfficiency(from, to),
    queryFn: () => dashboardApi.getMDTeamEfficiency({ from: from!, to: to! }),
    enabled: !!from && !!to,
  });
}
